<template>
<v-container class="pt-10" style="max-width:100%;" v-if="!isLoadingClients">
    <v-row class="ma-0 px-6 mt-6">
        <v-select class="mr-2" outlined dense v-model="selected_measurement" :items="old_measurements_list" item-value="id" item-text="name" label="Consulta" ></v-select>
    </v-row>

    <v-row class="ma-0">
        <v-stepper class="elevation-0 pb-12" v-model="step"  style="width:100%; min-height:calc(100vh - 120px);">
            <v-stepper-header class="elevation-0 px-3 pt-3">

                <v-stepper-step step="1" :complete="step>1" color="#e12826" @click="step=1"> TANITA </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step color="#e12826" step="2" :complete="step>2" @click="step=2"> Cinta Metrica </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step color="#e12826" step="3" :complete="step>3" @click="step=3"> Jackson & Pollock </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step color="#e12826" step="4" :complete="step>4" @click="step=4"> Durnin Womersley </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step color="#e12826" step="5" :complete="step>5" @click="step=5"> Yuhasz </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step color="#e12826" step="6" :complete="step>6" @click="step=6"> Resumen </v-stepper-step>

            </v-stepper-header>
            <!-- TANITA -->
            <v-stepper-content step="1" class="pt-0">
                <v-row class="ma-0">
                    <v-col cols="6">
                        <v-text-field label="Peso" v-model="measurement.weight" outlined suffix="kgs"></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.weight}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field label="Estatura" v-model="currentClient.height" outlined suffix="cms"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="6">
                        <v-text-field label="Kilos de grasa" v-model="measurement.fat_kg" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.fat_kg}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field label="Porcentaje de agua" suffix="%" v-model="measurement.water_percentage" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.water_percentage}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="6">
                        <v-text-field label="Kilos de masa magra" v-model="measurement.lean_mass_kg" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.lean_mass_kg}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field label="Edad metabolica" v-model="measurement.metabolic_age" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.metabolic_age}}</v-chip>
                        </v-row>
                    </v-col>

                    <v-col cols="6">
                        <v-text-field label="Grasa Visceral" v-model="measurement.visceral_fat" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.visceral_fat}}</v-chip>
                        </v-row>
                    </v-col>

                    <v-col cols="6">
                        <v-text-field label="Presión Arterial" v-model="measurement.arterial_pressure" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.arterial_pressure}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                
            </v-stepper-content>
            <!-- Cinta Metrica -->
            <v-stepper-content step="2" class="pt-0">
                <v-row class="ma-0">
                    <v-col :cols="currentClient.gender == 'Femenino' ? 4 : 6">
                        <v-text-field label="Cuello" v-model="measurement.neck" outlined suffix="cms"></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.neck}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col :cols="currentClient.gender == 'Femenino' ? 4 : 6">
                        <v-text-field label="Cintura" v-model="measurement.waist" outlined suffix="cms"></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.waist}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4" v-if="currentClient.gender == 'Femenino'">
                        <v-text-field label="Cadera" v-model="measurement.hip" outlined suffix="cms"></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.hip}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
            </v-stepper-content>
            <!-- Jackson & Pollock -->
            <v-stepper-content step="3" class="pt-0">
                <v-row class="ma-0">
                    <v-col cols="4" class="pb-0">
                        <v-card-title>Medida 1</v-card-title>
                    </v-col>
                    <v-col cols="4" class="pb-0">
                        <v-card-title>Medida 2</v-card-title>
                    </v-col>
                    <v-col cols="4" class="pb-0">
                        <v-card-title>Promedio</v-card-title>
                    </v-col>
                </v-row>
                <v-row class="ma-0" v-if="currentClient.gender == 'Masculino'" >
                    <v-col cols="4" class="pt-0">
                        <v-text-field label="Pecho" v-model="measurement.chest_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.chest_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4" class="pt-0">
                        <v-text-field label="Pecho" v-model="measurement.chest_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.chest_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4" class="pt-0">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.chest_one*1) + (measurement.chest_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((old_measurement.chest_one*1) + (old_measurement.chest_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0" v-if="currentClient.gender == 'Masculino'">
                    <v-col cols="4">
                        <v-text-field label="Abdomen" v-model="measurement.abs_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.abs_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Abdomen" v-model="measurement.abs_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.abs_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.abs_one*1) + (measurement.abs_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((old_measurement.abs_one*1) + (old_measurement.abs_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4">
                        <v-text-field label="Cuadriceps" v-model="measurement.quadriceps_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.quadriceps_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Cuadriceps" v-model="measurement.quadriceps_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.quadriceps_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.quadriceps_one*1) + (measurement.quadriceps_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((old_measurement.quadriceps_one*1) + (old_measurement.quadriceps_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0" v-if="currentClient.gender == 'Femenino'">
                    <v-col cols="4">
                        <v-text-field label="Triceps" v-model="measurement.triceps_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.triceps_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Triceps" v-model="measurement.triceps_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.triceps_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.triceps_one*1) + (measurement.triceps_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((old_measurement.triceps_one*1) + (old_measurement.triceps_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0" v-if="currentClient.gender == 'Femenino'">
                    <v-col cols="4">
                        <v-text-field label="Suprailiaco" v-model="measurement.suprailiac_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.suprailiac_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Suprailiaco" v-model="measurement.suprailiac_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.suprailiac_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.suprailiac_one*1) + (measurement.suprailiac_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((old_measurement.suprailiac_one*1) + (old_measurement.suprailiac_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
            </v-stepper-content>
            <!-- Durnin Womersley -->
            <v-stepper-content step="4" class="pt-0">
                <v-row class="ma-0">
                    <v-col cols="4" class="pb-0">
                        <v-card-title>Medida 1</v-card-title>
                    </v-col>
                    <v-col cols="4" class="pb-0">
                        <v-card-title>Medida 2</v-card-title>
                    </v-col>
                    <v-col cols="4" class="pb-0">
                        <v-card-title>Promedio</v-card-title>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4" class="pt-0">
                        <v-text-field label="Triceps" v-model="measurement.triceps_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.triceps_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4" class="pt-0">
                        <v-text-field label="Triceps" v-model="measurement.triceps_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.triceps_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4" class="pt-0">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.triceps_one*1) + (measurement.triceps_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((old_measurement.triceps_one*1) + (old_measurement.triceps_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4">
                        <v-text-field label="Biceps" v-model="measurement.biceps_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.biceps_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Biceps" v-model="measurement.biceps_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.biceps_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.biceps_one*1) + (measurement.biceps_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((old_measurement.biceps_one*1) + (old_measurement.biceps_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4">
                        <v-text-field label="Subescapulares" v-model="measurement.subscapularis_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.subscapularis_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Subescapulares" v-model="measurement.subscapularis_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.subscapularis_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.subscapularis_one*1) + (measurement.subscapularis_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((old_measurement.subscapularis_one*1) + (old_measurement.subscapularis_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4">
                        <v-text-field label="Suprailiaco" v-model="measurement.suprailiac_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.suprailiac_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Suprailiaco" v-model="measurement.suprailiac_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.suprailiac_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.suprailiac_one*1) + (measurement.suprailiac_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((old_measurement.suprailiac_one*1) + (old_measurement.suprailiac_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
            </v-stepper-content>
            <!-- Yuhasz -->
            <v-stepper-content step="5" class="pt-0">
                <v-row class="ma-0">
                    <v-col cols="4" class="pb-0">
                        <v-card-title>Medida 1</v-card-title>
                    </v-col>
                    <v-col cols="4" class="pb-0">
                        <v-card-title>Medida 2</v-card-title>
                    </v-col>
                    <v-col cols="4" class="pb-0">
                        <v-card-title>Promedio</v-card-title>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4" class="pt-0">
                        <v-text-field label="Triceps" v-model="measurement.triceps_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.triceps_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4" class="pt-0">
                        <v-text-field label="Triceps" v-model="measurement.triceps_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.triceps_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4" class="pt-0">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.triceps_one*1) + (measurement.triceps_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((measurement.triceps_one*1) + (measurement.triceps_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4">
                        <v-text-field label="Subescapulares" v-model="measurement.subscapularis_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.subscapularis_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Subescapulares" v-model="measurement.subscapularis_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.subscapularis_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.subscapularis_one*1) + (measurement.subscapularis_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((measurement.subscapularis_one*1) + (measurement.subscapularis_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4">
                        <v-text-field label="Abdomen" v-model="measurement.abs_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.abs_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Abdomen" v-model="measurement.abs_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.abs_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.abs_one*1) + (measurement.abs_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((measurement.abs_one*1) + (measurement.abs_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4">
                        <v-text-field label="Suprailiaco" v-model="measurement.suprailiac_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.suprailiac_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Suprailiaco" v-model="measurement.suprailiac_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.suprailiac_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.suprailiac_one*1) + (measurement.suprailiac_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((measurement.suprailiac_one*1) + (measurement.suprailiac_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4">
                        <v-text-field label="Cuadriceps" v-model="measurement.quadriceps_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.quadriceps_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Cuadriceps" v-model="measurement.quadriceps_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.quadriceps_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.quadriceps_one*1) + (measurement.quadriceps_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((measurement.quadriceps_one*1) + (measurement.quadriceps_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col cols="4">
                        <v-text-field label="Pantorrilla" v-model="measurement.calf_one" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.calf_one}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field label="Pantorrilla" v-model="measurement.calf_two" outlined></v-text-field>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{old_measurement.calf_two}}</v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-card-subtitle class="mx-0 mt-0 mb-2 pa-4" style="line-height:24px; border-radius:7px; font-weight:600; font-size:18px; background:#eeeeee;">{{(((measurement.calf_one*1) + (measurement.calf_two*1)) / 2 ).toFixed(2)}}</v-card-subtitle>
                        <v-row class="ma-0">
                            Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2">{{(((measurement.calf_one*1) + (measurement.calf_two*1)) / 2 ).toFixed(2)}}</v-chip>
                        </v-row>
                    </v-col>
                </v-row>
            </v-stepper-content>
            <!-- Resumen -->
            <v-stepper-content step="6" class="pt-0">
                <v-row class="ma-0 mb-3">
                    <v-col :cols="12/cards.length" v-for="(card, index) in cards" :key="index">
                        <v-card :color="card.title == 'Promedio' ? '#e12826' : 'white'" :dark="card.title == 'Promedio' ? true : false">
                            <v-checkbox color="#e12826" v-if="card.title != 'Promedio'" class="mt-0 pt-4" hide-details="true" style="transform:scale(0.8); display: inline-block;" v-model="consider_measure[card.id]" :label="card.title"></v-checkbox>
                            <v-card-subtitle class="pb-1" v-else>{{card.title}}</v-card-subtitle>
                            <v-card-title class="pt-0 pb-3">
                                {{( card.value * 1 ).toFixed(2)}}% <span style="font-size: 16px;" v-if="currentUser.user_measurements!=undefined">{{prevCard(currentUser.user_measurements[0].card, card)}}</span>
                            </v-card-title>
                        </v-card>
                    </v-col>
                </v-row>
                <div style="100%" class="ma-0 mb-6" v-if="isNotNull(measurement.weight)&&cards.length>0">

                    <v-row class="ma-0 mb-4">
                        <v-col cols="3">
                            <v-card dark color="black" class="pt-4">
                                <v-row class="ma-0" v-if="old_measurements!=undefined && old_measurements.length>0">
                                    <v-card-subtitle class="py-0">Anteriores: <v-chip v-for="(old_measurement, index) in old_measurements" :key="index" small class="ml-2 px-2" style="height:16px;">{{old_measurement.weight}}</v-chip></v-card-subtitle>
                                </v-row>
                                <v-card-title class="pt-0">Peso Corporal: <strong>{{' ' + measurement.weight + 'kgs'}}</strong></v-card-title>
                                <v-card-subtitle v-if="old_measurements!=undefined && old_measurements.length>0">
                                    <v-icon color="success" v-if="(old_measurements[0].weight*1).toFixed(2)>(measurement.weight*1).toFixed(2)">mdi-arrow-down-bold</v-icon>
                                    <v-icon color="error" v-else-if="(old_measurements[0].weight*1).toFixed(2)<(measurement.weight*1).toFixed(2)">mdi-arrow-up-bold</v-icon>
                                    <v-icon color="primary" v-else>mdi-arrow-right-bold</v-icon>
                                    {{Math.abs(old_measurements[0].weight - measurement.weight).toFixed(2)}} kgs
                                </v-card-subtitle>
                            </v-card>
                        </v-col>
                        <v-col cols="3">
                            <v-card dark color="black" class="pt-4">
                                <v-row class="ma-0" v-if="old_measurements!=undefined && old_measurements.length>0">
                                    <v-card-subtitle class="py-0">Anteriores: <v-chip v-for="(old_fat_percentage, index) in old_fat_percentages" :key="index" small class="ml-2 px-2" style="height:16px;">{{old_fat_percentage.toFixed(2)}}</v-chip></v-card-subtitle>
                                </v-row>
                                <v-card-title class="pt-0">Grasa Corporal: <strong>{{' ' + (fat_percentage).toFixed(2)}}%</strong></v-card-title>
                                <v-card-subtitle v-if="old_measurements!=undefined && old_measurements.length>0">
                                    <v-icon color="success" v-if="old_fat_percentages[0].toFixed(2)>fat_percentage.toFixed(2)">mdi-arrow-down-bold</v-icon>
                                    <v-icon color="error" v-else-if="old_fat_percentages[0].toFixed(2)<fat_percentage.toFixed(2)">mdi-arrow-up-bold</v-icon>
                                    <v-icon color="primary" v-else>mdi-arrow-right-bold</v-icon>
                                    {{Math.abs(old_fat_percentages[0]-fat_percentage).toFixed(2)}}%
                                </v-card-subtitle>
                            </v-card>
                        </v-col>
                        <v-col cols="3">
                            <v-card dark color="black" class="pt-4">
                                <v-row class="ma-0" v-if="old_measurements!=undefined && old_measurements.length>0">
                                    <v-card-subtitle class="py-0">Anteriores: <v-chip v-for="(old_fat_percentage, index) in old_fat_percentages" :key="index" small class="ml-2 px-2" style="height:16px;">{{((old_measurements[index].weight / 100) * old_fat_percentage).toFixed(2)}}</v-chip></v-card-subtitle>
                                </v-row>
                                <v-card-title class="pt-0">Masa Grasa: <strong>{{' ' + ((measurement.weight / 100) * fat_percentage).toFixed(2)}}kgs</strong></v-card-title>
                                <v-card-subtitle v-if="old_measurements!=undefined && old_measurements.length>0">
                                    <v-icon color="success" v-if="((old_measurements[0].weight / 100) * old_fat_percentages[0]).toFixed(2)>((measurement.weight / 100) * fat_percentage).toFixed(2)">mdi-arrow-down-bold</v-icon>
                                    <v-icon color="error" v-else-if="((old_measurements[0].weight / 100) * old_fat_percentages[0]).toFixed(2)<((measurement.weight / 100) * fat_percentage).toFixed(2)">mdi-arrow-up-bold</v-icon>
                                    <v-icon color="primary" v-else>mdi-arrow-right-bold</v-icon>
                                    {{Math.abs(((old_measurements[0].weight / 100) * old_fat_percentages[0])-((measurement.weight / 100) * fat_percentage)).toFixed(2)}} kgs
                                </v-card-subtitle>
                            </v-card>
                        </v-col>
                        <v-col cols="3">
                            <v-card dark color="black" class="pt-4">
                                <v-row class="ma-0" v-if="old_measurements!=undefined && old_measurements.length>0">
                                    <v-card-subtitle class="py-0">Anteriores: <v-chip v-for="(old_fat_percentage, index) in old_fat_percentages" :key="index" small class="ml-2 px-2" style="height:16px;">{{(old_measurements[index].weight - ((old_measurements[index].weight / 100) * old_fat_percentage)).toFixed(2)}}</v-chip></v-card-subtitle>
                                </v-row>
                                <v-card-title class="pt-0">Masa Magra: <strong>{{' ' + (measurement.weight - ((measurement.weight / 100) * fat_percentage)).toFixed(2)}}kgs</strong></v-card-title>
                                <v-card-subtitle v-if="old_measurements!=undefined && old_measurements.length>0">
                                    <v-icon color="error" v-if="(old_measurements[0].weight - ((old_measurements[0].weight / 100) * old_fat_percentages[0])).toFixed(2)>(measurement. weight - ((measurement.weight / 100) * fat_percentage)).toFixed(2)">mdi-arrow-down-bold</v-icon>
                                    <v-icon color="success" v-else-if="(old_measurements[0].weight - ((old_measurements[0].weight / 100) * old_fat_percentages[0])).toFixed(2)<(measurement. weight - ((measurement.weight / 100) * fat_percentage)).toFixed(2)">mdi-arrow-up-bold</v-icon>
                                    <v-icon color="primary" v-else>mdi-arrow-right-bold</v-icon>
                                    {{Math.abs((old_measurements[0].weight - ((old_measurements[0].weight / 100) * old_fat_percentages[0]))-(measurement. weight - ((measurement.weight / 100) * fat_percentage))).toFixed(2)}} kgs
                                </v-card-subtitle>
                            </v-card>
                        </v-col>
                        
                    </v-row>

                    <v-row class="ma-0">
                        <v-col cols="4">
                            <v-icon style="color:#2196F3!important;">mdi-arrow-right-bold</v-icon> Valor Calórico Total K&M Kcal: <strong>{{' ' + (this.met_basal_kcal*this.currentClient.physical_activity_index).toFixed(2)}}</strong>
                        </v-col>
                        <v-col cols="4">
                            <v-icon :style="'color:' + arrowColor('up') + '!important;'">mdi-arrow-up-bold</v-icon>Valor calórico para subir peso: <strong>{{' ' + ((this.met_basal_kcal*this.currentClient.physical_activity_index)+(calorie_adjustment*1)).toFixed(2)}}</strong>
                        </v-col>
                        <v-col cols="4">
                            <v-icon :style="'color:' + arrowColor('down') + '!important;'">mdi-arrow-down-bold</v-icon>Valor calórico para bajar peso: <strong>{{' ' + ((this.met_basal_kcal*this.currentClient.physical_activity_index)-(calorie_adjustment*1)).toFixed(2)}}</strong>
                        </v-col>
                    </v-row>

                    <v-row class="ma-0">
                        <v-col cols="4">
                            <v-autocomplete label="Factor de Actividad" v-model="currentClient.physical_activity_index" outlined :items="indicesList" item-value="value" item-text="title">
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-item-content>
                                            <v-list-item-title>{{data.item.title}}</v-list-item-title>
                                            <v-list-item-subtitle>{{data.item.subtitle}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field label="Meta % Grasa" v-model="measurement.target_body_fat_percentage" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field label="Ajuste de Calorias" v-model="calorie_adjustment" outlined></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="ma-0 mb-2">
                        <v-col cols="4" style="display: flex;" class="pt-0">
                            <v-card color="#9e9e9e" style="margin:auto; padding:10px 20px; color:white;">
                                <v-card-title class="pa-0" style="margin: auto;">
                                    <v-card-subtitle class="pa-0 pr-2">
                                    Porcentaje para lograr meta: 
                                    </v-card-subtitle>
                                    <strong>{{(measurement.target_body_fat_percentage-fat_percentage).toFixed(2)}}%</strong>
                                </v-card-title>
                                <v-row class="ma-0" v-if="old_fat_percentages!=undefined&&old_fat_percentages.length>0">
                                    <v-card-subtitle class="py-0">Anteriores: <v-chip v-for="(old_fat_percentage, index) in old_fat_percentages" :key="index" small class="ml-2 px-2" style="height:16px;">{{(measurement.target_body_fat_percentage-old_fat_percentage).toFixed(2)}}%</v-chip></v-card-subtitle>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="4" style="display: flex;" class="pt-0">
                            <v-card color="#9e9e9e" style="margin:auto; padding:10px 20px; color:white;">
                                <v-card-title class="pa-0" style="margin: auto;">
                                    <v-card-subtitle class="pa-0 pr-2">
                                    Kilos para lograr meta: 
                                    </v-card-subtitle>
                                    <strong>{{((this.measurement.weight/100)*(measurement.target_body_fat_percentage-fat_percentage)).toFixed(2)}}kg</strong>
                                </v-card-title>
                                <v-row class="ma-0" v-if="old_fat_percentages!=undefined&&old_fat_percentages.length>0">
                                    <v-card-subtitle class="py-0">Anteriores: <v-chip v-for="(old_fat_percentage, index) in old_fat_percentages" :key="index" small class="ml-2 px-2" style="height:16px;">{{(((measurement.weight/100)*(measurement.target_body_fat_percentage-fat_percentage))-((old_measurements[index].weight/100)*(old_fat_percentage-fat_percentage))).toFixed(2)}}kgs</v-chip></v-card-subtitle>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="4" style="display: flex;" class="pt-0">
                            <v-card color="#9e9e9e" style="margin:auto; padding:10px 20px; color:white;">
                                <v-card-title class="pa-0" style="margin: auto;">
                                    <v-card-subtitle class="pa-0 pr-2">
                                    Semanas para lograr meta: 
                                    </v-card-subtitle>
                                    <strong>{{weeks_to_goal}}</strong>
                                </v-card-title>
                                
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row class="ma-0">
                        <v-col cols="6">
                            <v-text-field label="No. de Comidas Principales" v-model="measurement.plates" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Refrigerios" v-model="measurement.snacks" outlined></v-text-field>
                        </v-col>
                    </v-row>

                </div>
            </v-stepper-content>
        </v-stepper>

        <v-row class="ma-0" style="bottom: 30px; position: absolute; right: 30px;">
            <v-spacer/>
            <v-btn v-if="step>1" color="#e12826" dark text class="elevation-0 mr-4" @click="step = step - 1">
                Regresar
            </v-btn>
            <v-btn v-if="step<6" color="#e12826" dark text class="elevation-0 mr-4" @click="step = step + 1">
                Siguiente
            </v-btn>
            <v-btn v-if="step!=6" color="#e12826" dark class="elevation-0 mr-4" @click="step = 6">
                Resumen
            </v-btn>
            <v-btn v-else-if="selected_measurement==undefined" color="black" dark class="elevation-0 mr-4" @click="save()">
                Guardar
            </v-btn>
        </v-row>

        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-row>  

    

</v-container>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            selected_measurement:undefined,
            old_measurements:[],
            headers:[
                { text: '', value: 'profile_photo_path' },
                { text: 'Nombre', value: 'name' },
                { text: 'Edad', value: 'birthdate' },
                { text: 'Estatura', value: 'height' },
                { text: 'Indice de Actividad', value: 'physical_activity_index' },
                { text: '', value: 'actions' },
            ],
            user_age:0,
            is_competence:false,
            type:'',
            step:1,
            measurement:{
                user_id:'',
                //tanita
                weight:'',
                height:'',
                fat_kg:'',
                lean_mass_kg:'',
                water_percentage:'',
                metabolic_age:'',
                visceral_fat:'',
                arterial_pressure:'',
                /* plicometro */
                //hombre
                chest_one:'',
                chest_two:'',
                abs_one:'',
                abs_two:'',
                quadriceps_one:'',
                quadriceps_two:'',
                //mujer (hombre competencia)
                triceps_one:'',
                triceps_two:'',
                suprailiac_one:'',
                suprailiac_two:'',
                quadriceps_one:'',
                quadriceps_two:'',
                //competencia
                biceps_one:'',
                biceps_two:'',
                subscapularis_one:'',
                subscapularis_two:'',
                calf_one:'',
                calf_two:'',
                //cinta metrica
                neck:'',
                waist:'',//cintura
                hip:'',//cadera

                appointment_id:'',

                plates:'',
                snacks:'',      
                target_body_fat_percentage:6,          
            },
            loader:false,
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            isLoadingClients: true,
            searchClients: null,
            currentClient:undefined,
            clientsList:[],
            calorie_adjustment:500,
            consider_measure:{bascula: true, tape:true, jp:true, dw:true, yuhasz:true}
        };
    },
    computed:{
        isDirty(){
            function isNotNullUndefinedOrEmpty(value) {
                return value !== null && value !== undefined && value !== '';
            }
            for (let key in this.measurement) {
                if(key!='user_id'&&key!='target_body_fat_percentage'){
                    const value = this.measurement[key];
                    if (isNotNullUndefinedOrEmpty(value)) {
                        return true
                    }
                }
            }
        },
        old_measurements_list(){
            return this.old_measurements.sort((a, b) => b.id - a.id).map(id=>{return{
                ...id,
                name: 'Toma de medidas ' + id.created_at.slice(0,10)
            }})
        },
        clientId(){
            return this.$route.params.id
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        },
        old_fat_percentages(){
            var percentages = []
            for(var j=0; j<this.old_measurements.length; j++){
                var sum = 0, length = 0
                if(this.old_measurements[j].results!=undefined){
                    for(var i=0; i<this.old_measurements[j].results.length; i++){
                        if(this.consider_measure[this.old_measurements[j].results[i].id]){
                            sum = sum + this.old_measurements[j].results[i].value
                            length = length + 1
                        }
                    }
                    percentages.push(sum/length)   
                }
            }
            return percentages
        },
        fat_percentage(){
            var sum = 0, length = 0
            for(var i=0; i<this.cards.length; i++){
                if(this.consider_measure[this.cards[i].id]){
                    sum = sum + this.cards[i].value
                    length = length + 1
                }
            }
            return sum/length
        },
        met_basal_kcal(){
            return 370+(21.6*(this.measurement.weight - ((this.measurement.weight / 100) * this.fat_percentage)))
        },
        cards(){
            var cards = []
            var sum = 0
            var length = 0
            if(this.measurement.weight!='' && this.measurement.fat_kg!=''){
                cards.push({title:'Báscula', value:((100/this.measurement.weight)*this.measurement.fat_kg), id:'bascula'})
            }
            if(
                this.isNotNull(this.measurement.quadriceps_one)&&this.isNotNull(this.measurement.quadriceps_two)&&(
                    (this.currentClient.gender=='Masculino'&&
                        this.isNotNull(this.measurement.chest_one)&&this.isNotNull(this.measurement.chest_two)&&
                        this.isNotNull(this.measurement.abs_one)&&this.isNotNull(this.measurement.abs_two)
                    )||
                    (this.currentClient.gender=='Femenino'&&
                        this.isNotNull(this.measurement.triceps_one)&&this.isNotNull(this.measurement.triceps_two)&&
                        this.isNotNull(this.measurement.suprailiac_one)&&this.isNotNull(this.measurement.suprailiac_two)
                    )
                )
            ){
                if(this.consider_measure.jp){
                    sum = sum + (this.jacksonPollock*1)
                    length = length + 1
                }
                cards.push({title:'Jackson & Pollock', value:(this.jacksonPollock*1), id:'jp'})
            }
            if(
                this.isNotNull(this.measurement.neck) && 
                this.isNotNull(this.measurement.waist) && 
                (this.currentClient.gender=='Masculino' || (this.isNotNull(this.measurement.hip) && this.currentClient.gender=='Femenino'))){
                if(this.consider_measure.tape){
                    sum = sum + (this.tapePrcentage*1)
                    length = length + 1
                }
                cards.push({title:'Cinta Métrica', value:(this.tapePrcentage*1), id:'tape'})
            }
            if(
                this.isNotNull(this.measurement.triceps_one)&&this.isNotNull(this.measurement.triceps_two)&&
                this.isNotNull(this.measurement.biceps_one)&&this.isNotNull(this.measurement.biceps_two)&&
                this.isNotNull(this.measurement.subscapularis_one)&&this.isNotNull(this.measurement.subscapularis_two)&&
                this.isNotNull(this.measurement.suprailiac_one)&&this.isNotNull(this.measurement.suprailiac_two)
            ){
                if(this.consider_measure.dw){
                    sum = sum + (this.durninWomersley*1)
                    length = length + 1
                }
                cards.push({title:'Durnin Womersley', value:(this.durninWomersley*1), id:'dw'})
            }
            if(
                this.isNotNull(this.measurement.triceps_one)&&this.isNotNull(this.measurement.triceps_two)&&
                this.isNotNull(this.measurement.subscapularis_one)&&this.isNotNull(this.measurement.subscapularis_two)&&
                this.isNotNull(this.measurement.abs_one)&&this.isNotNull(this.measurement.abs_two)&&
                this.isNotNull(this.measurement.suprailiac_one)&&this.isNotNull(this.measurement.suprailiac_two)&&
                this.isNotNull(this.measurement.quadriceps_one)&&this.isNotNull(this.measurement.quadriceps_two)&&
                this.isNotNull(this.measurement.calf_one)&&this.isNotNull(this.measurement.calf_two)
            ){
                if(this.consider_measure.yuhasz){
                    sum = sum + (this.yuhasz*1)
                    length = length + 1
                }
                cards.push({title:'Yuhasz', value:(this.yuhasz*1), id:'yuhasz'})
            }
            /*if(cards.length>1){
                cards.push({title:'Promedio', value: sum/length})
            }*/
            return cards
        },
        tapePrcentage(){
            if(this.currentClient.gender == 'Masculino'){
                return 495 / ( 1.0324 - 0.19077 * Math.log10( (this.measurement.waist*1) - (this.measurement.neck*1) ) + 0.15456 * Math.log10( (this.currentClient.height*1) ) ) - 450
            }
            else if(this.currentClient.gender == 'Femenino'){
                console.log(this.measurement)
                //return 163.205 * Math.log10((this.measurement.waist*1) + (this.measurement.hip*1) - (this.measurement.neck*1)) - 97.684 * Math.log10(this.currentClient.height*1) - 78.387;
                return 495 / ( 1.29579 - 0.35004 * Math.log10( (this.measurement.waist*1) + (this.measurement.hip*1) - (this.measurement.neck*1) ) + 0.22100 * Math.log10( (this.currentClient.height*1) ) ) - 450
            }
        },

        jacksonPollock(){
            //Males
            if(this.currentClient.gender == 'Masculino'){
                var sum = 
                (((this.measurement.chest_one*1) + (this.measurement.chest_two*1))/2) + 
                (((this.measurement.abs_one*1) + (this.measurement.abs_two*1))/2) + 
                (((this.measurement.quadriceps_one*1) + (this.measurement.quadriceps_two*1))/2)
                var jp_result = 1.10938 - (0.0008267 * sum) + (0.0000016 * (sum * sum)) - (0.0002574 * this.user_age)
                return ((495/jp_result)-450).toFixed(2)
            }
            //Females
            else if(this.currentClient.gender == 'Femenino'){
                var sum = 
                (((this.measurement.triceps_one*1) + (this.measurement.triceps_two*1))/2) + 
                (((this.measurement.suprailiac_one*1) + (this.measurement.suprailiac_two*1))/2) + 
                (((this.measurement.quadriceps_one*1) + (this.measurement.quadriceps_two*1))/2)
                var jp_result = 1.0994921 - (0.0009929 * sum) + (0.0000023 * (sum * sum)) - (0.00013929 * this.user_age)
                return ((495/jp_result)-450).toFixed(2)
            }
        },
        durninWomersley(){
            var calc = 0
            var log = 
            (((this.measurement.triceps_one*1) + (this.measurement.triceps_two*1))/2)+//Tríceps
            (((this.measurement.biceps_one*1) + (this.measurement.biceps_two*1))/2)+//Biceps
            (((this.measurement.subscapularis_one*1) + (this.measurement.subscapularis_two*1))/2)+//Subescapular
            (((this.measurement.suprailiac_one*1) + (this.measurement.suprailiac_two*1))/2)//Suprailiac

            if(this.user_age<17){
                if(this.currentClient.gender=='Masculino'){
                    calc = 1.1533 - (0.0643 * Math.log10(log))
                }else if(this.currentClient.gender=='Femenino'){
                    calc = 1.1369 - (0.0598 * Math.log10(log))
                }
            }else if(this.user_age>17 && this.user_age<20){
                if(this.currentClient.gender=='Masculino'){
                    calc = 1.1620 - (0.0630 * Math.log10(log))
                }else if(this.currentClient.gender=='Femenino'){
                    calc = 1.1549 - (0.0678 * Math.log10(log))
                }
            }else if(this.user_age>20 && this.user_age<30){
                if(this.currentClient.gender=='Masculino'){
                    calc = 1.1631 - (0.0632 * Math.log10(log))
                }else if(this.currentClient.gender=='Femenino'){
                    calc = 1.1599 - (0.0717 * Math.log10(log))
                }
            }else if(this.user_age>30 && this.user_age<40){
                if(this.currentClient.gender=='Masculino'){
                    calc = 1.1422 - (0.0544 * Math.log10(log))
                }else if(this.currentClient.gender=='Femenino'){
                    calc = 1.1423 - (0.0632 * Math.log10(log))
                }
            }else if(this.user_age>40 && this.user_age<50){
                if(this.currentClient.gender=='Masculino'){
                    calc = 1.1620 - (0.0700 * Math.log10(log))
                }else if(this.currentClient.gender=='Femenino'){
                    calc = 1.1333 - (0.0612 * Math.log10(log))
                }
            }else if(this.user_age>50){
                if(this.currentClient.gender=='Masculino'){
                    calc = 1.1715 - (0.0779 * Math.log10(log))
                }else if(this.currentClient.gender=='Femenino'){
                    calc = 1.1339 - (0.0645 * Math.log10(log))
                }
            }

            return ((4.95/calc)-4.5)*100
        },
        //Yuhasz Puntos de Medición 
        yuhasz(){
            var sum = 
            (((this.measurement.triceps_one*1) + (this.measurement.triceps_two*1))/2)+//Tríceps
            (((this.measurement.subscapularis_one*1) + (this.measurement.subscapularis_two*1))/2)+//Subescapular
            (((this.measurement.abs_one*1) + (this.measurement.abs_two*1))/2)+//Abdominal
            (((this.measurement.suprailiac_one*1) + (this.measurement.suprailiac_two*1))/2)+//Suprailiaco
            (((this.measurement.quadriceps_one*1) + (this.measurement.quadriceps_two*1))/2)+//Muslo
            (((this.measurement.calf_one*1) + (this.measurement.calf_two*1))/2)//Pantorrilla
            //Yuhasz Fórmula para Hombres
            if(this.currentClient.gender == 'Masculino'){
                return (0.1051 * sum) + 2.585
            }
            //Yuhasz Fórmula para Mujeres
            else if(this.currentClient.gender == 'Femenino'){
                return (0.1548 * sum) + 3.580
            }
        },
        indicesList(){
            return [
                {subtitle: "Nada o poco ejercicio, trabajo de escritorio ", title:"Sedentario", value: "1.200"},
                {subtitle: "Ejercicio Ligero 1 a 3 días/semana", title:"Algo Activo", value: "1.375"},
                {subtitle: "Ejercicio Moderado 3 a 5 días/semana", title:"Activo", value: "1.550"},
                {subtitle: "Ejercicio Fuerte 6 a 7 días/semana", title:"Muy Activo", value: "1.725"},
                {subtitle: "Ejercicio fuerte mas trabajo físico, o Entrenamiento 2 veces diarias", title:"Extra Activo", value: "1.900"}
            ]
        },
        weeks_to_goal(){
            return (((this.measurement.weight - ((this.measurement.weight / 100) * this.measurement.target_body_fat_percentage)) - (this.measurement.weight - ((this.measurement.weight / 100) * this.fat_percentage)))/0.5).toFixed(2)
        }
    },
    methods:{
        
        prevCard(old_cards, new_card){
            if(old_cards!=undefined){
                return ' Anterior: ' + this.old_cards.filter(card=>card.title == new_card.title).value
            }else{
                return ''
            }
        },
        indices(value){
            return this.indicesList.filter(item=>item.value == value).map(item.title)[0]
        },
        age(date){
            var today = new Date();
            var birthdate = new Date(date + ' 00:00:00');
            var edadEnMilisegundos = today - birthdate; // Diferencia en milisegundos
            return edadEnMilisegundos / (1000 * 60 * 60 * 24 * 365.25); // Conversión a años con decimales
        },
        arrowColor(direction){
            if(direction=='up'){
                if(this.fat_percentage>this.measurement.target_body_fat_percentage){
                    return '#F44336'
                }else{
                    return '#4CAF50'
                }
            }else if(direction=='down'){
                if(this.fat_percentage<this.measurement.target_body_fat_percentage){
                    return '#F44336'
                }else{
                    return '#4CAF50'
                }
            }
        },
        isNotNull(value){
            if(value!='' && value!=null && value!=undefined){
                return true
            }else{
                return false
            }
        },
        save(){
            this.loader = true
            const measurement = [this.measurement].map(item => {
                return{ 
                    ...item,
                    fat_percentage: this.physical_activity_index,
                    //new_fat_percentage: this.physical_activity_index,
                    calorie_adjustment: this.physical_activity_index,
                    physical_activity_index: this.currentClient.physical_activity_index,
                    weeks_to_goal:this.weeks_to_goal,
                    results:this.cards,
                    height:this.currentClient.height
                }
            })[0]
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/user_measurements", measurement).then(res => {
                axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/users/" + this.currentClient.id, {height:this.currentClient.height}).then(res => {
                    this.loader = false
                    this.snackbar = {
                        show: true,
                        message: 'Medidas registradas con éxito',
                        color: 'success'
                    }
                }).catch(error=>{
                    this.loader = false
                    this.snackbar = {
                        show: true,
                        message: 'Hubo un error al actualizar la estatura del paciente',
                        color: 'red'
                    }
                })

            }).catch(error=>{
                this.loader = false
                this.snackbar = {
                    show: true,
                    message: 'Hubo un error al guadrar las medidas, verifica que los datos esten completos',
                    color: 'red'
                }
            })
        }
    },
    watch:{
        isDirty:{
            handler(){
                if(this.isDirty){
                    localStorage.setItem('isDirty', true)
                }
            }, deep:true
        },
        selected_measurement:{
            handler(){
                this.measurement = this.old_measurements.filter(measurement=>measurement.id == this.selected_measurement)[0]
                this.old_measurements = this.old_measurements.filter(measurement=>measurement.id != this.selected_measurement)
            }, deep: true
        },
        clientId:{
            handler(){
                this.isLoadingClients = true
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/users/" + this.$route.params.id).then(res => {
                    this.measurement.user_id = this.clientId
                    this.currentClient = res.data.data
                    this.user_age =  this.age(res.data.data.birthdate);
                    this.isLoadingClients = false
                })
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/user_measurements?filter[user.id]=" + this.$route.params.id ).then(response => {
                    this.old_measurements = response.data.data.slice(0,3).sort((a, b) => a.id - b.id)
                })
            }
        }
    },
    created(){
        axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/user_measurements?filter[user.id]=" + this.$route.params.id ).then(response => {
            this.old_measurements = response.data.data.slice(0,3).sort((a, b) => a.id - b.id)
        })
        this.isLoadingClients = true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/users/" + this.$route.params.id).then(res => {
                this.measurement.user_id = this.clientId
                this.currentClient = res.data.data
                this.user_age =  this.age(res.data.data.birthdate);
                this.isLoadingClients = false
            })
    }
};
</script>